import React, { useEffect, useState } from 'react';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from './bodyScroll';

export interface ILockScroll {
  visible: boolean;
  children: React.ReactElement
}

const getPropsVisible = (props: ILockScroll) => {
  const { visible: componentVisible, children } = props;
  let childrenVisible = false;
  if (componentVisible === undefined) {
    if (Array.isArray(children)) {
      childrenVisible = children.some(item => item.props.visible);
    }
    if (children.props) {
      childrenVisible = children.props.visible;
    }
    return childrenVisible;
  } else {
    childrenVisible = componentVisible;
  }
  return childrenVisible;
};

const LockScroll = (props) => {
  const { children } = props;
  const [dom] = useState(document.createElement('div'));

  const visible = getPropsVisible(props);

  useEffect(() => {
    if (visible) {
      document.body.appendChild(dom);
      disableBodyScroll(dom, {
        allowTouchMove: el => {
          while (el && el !== document.body) {
            const className = el.className;
            if (className && (
              className.indexOf('za-modal__dialog') > 0 ||
              className.indexOf('za-modal__body') > 0 ||
              className.indexOf('za-popup--show') > 0
            )) {
              return true;
            }
            el = el.parentElement;
          }
        },
      });
    } else {
      enableBodyScroll(dom);
      if (dom.parentNode) {
        dom.parentNode.removeChild(dom);
      }
    }
    return () => {
      clearAllBodyScrollLocks();
      if (dom.parentNode) {
        dom.parentNode.removeChild(dom);
      }
    };
  }, [visible]);

  if (!children) {
    return;
  }

  return children;
};

export default LockScroll;
